import { call, put } from "redux-saga/effects";

import { apiGeneral, notify } from "services";
import { requestErrorHandler } from "utils";
import { DeleteCarrierResponsibleEmailActions } from "store/ducks/settings/carrier-responsible-email";

export function* deleteCarrierResponsibleEmailRequest(action: any) {
  try {
    const { id, onSuccess } = action;

    const { data: responseBody } = yield call(
      apiGeneral.delete,
      `/carrier-responsible-email/delete/${id}`
    );

    const { data } = responseBody;
    yield put(DeleteCarrierResponsibleEmailActions.success(data));
    notify("success", "E-mail responsável deletado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(DeleteCarrierResponsibleEmailActions.failure(errorMessage));
  }
}
